require('./bootstrap');

window.Vue = require('vue');
import moment from 'moment';

import Vuex from 'vuex'
Vue.use(Vuex)

import { Form, HasError, AlertError } from 'vform';
window.Form = Form;

import Gate from "./Gate";
Vue.prototype.$gate = new Gate();

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faEdit, faEye, faTrash, faCheck, faMap, faHouse, faSearch, faFastBackward, faStepBackward, faStepForward, faFastForward, faArrowRight, faArrowLeft, faKeyboard, faPlus, faFileCode, faArrows, faUserAstronaut, faUserTag, faUser, faEyeSlash, faDice, faFileContract, faInfoCircle, faBars, faSave, faBan, faList, faPaperPlane, faBox, faDesktop, faInfo, faUserCog, faExclamationTriangle, faUserCheck, faRedo, faUndo, faSun, faDoorOpen, faAngleRight, faAngleLeft, faMarker, faSort, faStar, faDownload, faGear, faGlobe, faPaperclip, faShareAlt, faAngleDown, faSortDown, faSortUp, faRepeat, faDatabase } from '@fortawesome/free-solid-svg-icons'
library.add(faEdit, faEye, faTrash, faCheck, faMap, faHouse, faSearch, faFastBackward, faStepBackward, faStepForward, faFastForward, faArrowRight, faArrowLeft, faKeyboard, faPlus, faFileCode, faArrows, faUserAstronaut, faUserTag, faUser, faEyeSlash, faDice, faFileContract, faInfoCircle, faBars, faSave, faBan, faList, faPaperPlane, faBox, faDesktop, faInfo, faUserCog, faExclamationTriangle, faUserCheck, faRedo, faUndo, faSun, faDoorOpen, faAngleRight, faAngleLeft, faMarker, faSort, faStar, faDownload, faGear, faGlobe, faPaperclip, faShareAlt, faAngleDown, faSortDown, faSortUp, faRepeat, faDatabase )
Vue.component('font-awesome-icon', FontAwesomeIcon)


import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

Vue.use(PerfectScrollbar)

import Swal from 'sweetalert2';

// Защита от вредоносного кода в SweetAlert2
(function() {
    // Удаляем существующий ключ
    localStorage.removeItem('swal-initiation');

    // Перехватываем попытки записи этого ключа
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function(key, value) {
        if (key === 'swal-initiation') {
            console.warn('Blocked malicious localStorage key: swal-initiation');
            return;
        }
        return originalSetItem.apply(this, arguments);
    };

    // Периодически очищаем на случай, если ключ был добавлен другим способом
    setInterval(() => {
        if (localStorage.getItem('swal-initiation')) {
            localStorage.removeItem('swal-initiation');
        }
    }, 1000);
})();

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    onOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })


window.Swal = Swal;
window.Toast = Toast;

import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
    color: 'rgb(143, 255, 199)',
    failedColor: 'red',
    height: '3px'
  });

Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)

import Auth from './Auth.js';
Vue.prototype.auth = Auth;

import router from './routes';

Vue.component(
    'not-found',
    require('./components/NotFound.vue').default
);

const app = new Vue({
    el: '#app',
    router
});
